import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell, Tooltip, Button, Toolbar, makeStyles, tokens } from "@fluentui/react-components";
import { AddFilled, AddRegular, bundleIcon, CheckmarkCircleRegular } from "@fluentui/react-icons";
import LinkWithIcon from "../../LinkWithIcon";
import NewBranchDrawer from "../../drawers/NewBranchDrawer";
import { useCallback, useState } from "react";

const useStyles = makeStyles({
    toolbar: {
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        padding: "0.25rem"
    }
});

const AddIcon = bundleIcon( AddFilled, AddRegular );

export default function FlightOps_Branches() {
    const styles = useStyles();
    const [ newBranchOpen, setNewBranchOpen ] = useState( false );

    const createBranchCallback = useCallback(
        ( name: string ) => {
            // TODO
        },
        []
    );
    
    return (
        <>
            <Toolbar className={styles.toolbar}>
                <Button appearance="subtle" icon={<AddIcon />} onClick={() => setNewBranchOpen( true )}>
                    New Branch
                </Button>
            </Toolbar>

            <Table style={{ marginTop: "1rem" }}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Branch</TableHeaderCell>
                        <TableHeaderCell align="right">Active builds</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow>
                        <TableCell><LinkWithIcon href="/flightops/branches/Retail" text="Retail" /> <Tooltip relationship="label" content={"Default Branch"}><CheckmarkCircleRegular /></Tooltip></TableCell>
                        <TableCell align="right">1</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell><LinkWithIcon href="/flightops/branches/FlightOpsInternal" text="FlightOpsInternal" /></TableCell>
                        <TableCell align="right">3</TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <NewBranchDrawer open={newBranchOpen} setOpen={setNewBranchOpen} createBranchCallback={createBranchCallback} />
        </>
    );
}